<div class="loader">
    <div class="loader__content">
        <ng-content />
    </div>
</div>